/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ month: NonNullable<unknown> }} Partner_Detail_Empty_Month_TitleInputs */



/**
* | output |
* | --- |
* | "No periods closed in {month}" |
*
* @param {Partner_Detail_Empty_Month_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_detail_empty_month_title = /** @type {((inputs: Partner_Detail_Empty_Month_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Detail_Empty_Month_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Keine Zeiträume in ${i?.month} abgeschlossen`)
	return /** @type {LocalizedString} */ (`No periods closed in ${i?.month}`)
});